"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateChecklist = exports.serializeChecklist = void 0;
const serializeChecklist = (item) => {
    const itemOptions = item.data.items;
    if (!Array.isArray(itemOptions) ||
        !itemOptions.some(({ checked }) => checked)) {
        return "";
    }
    return itemOptions
        .filter(({ checked }) => checked)
        .map(({ text }) => text)
        .join(", ");
};
exports.serializeChecklist = serializeChecklist;
const validateChecklist = (item) => {
    const itemOptions = item.data.items;
    if (!item.required ||
        itemOptions?.every((item) => !item.text.trim() || item.checked)) {
        return { valid: true };
    }
    return {
        valid: false,
        error: { message: "Must complete all checklist items." },
    };
};
exports.validateChecklist = validateChecklist;
//# sourceMappingURL=checklist.js.map